import { render, staticRenderFns } from "./NotifyMessage.vue?vue&type=template&id=2ada9328&scoped=true&"
import script from "./NotifyMessage.vue?vue&type=script&lang=js&"
export * from "./NotifyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada9328",
  null
  
)

export default component.exports